const MonitorOperadorCallCenterHome = () => import(/* webpackChunkName: "group-callcenter-monitor" */ '../_views/MonitorOperadorCallCenterHome')
import { permissionsMonitorOperador } from '../../../utils/permissionsCallCenter'

export default [
  {
    path: '/monitor-operador',
    meta: { requiresAuth: true, permissions: [...permissionsMonitorOperador] },
    component: MonitorOperadorCallCenterHome,
    // name: 'onlyMonitorOperador',
  },
]